window.addEventListener('DOMContentLoaded', () =>{
  var listingRecipes = new Swiper(".listing-recipe-wrapper .swiper",{
    autoplay: true,
    loop: false,
    breakpoints: {
      390:{
        slidesPerView: 2
      },
      768: {
        slidesPerView: 4
      },
      1024: {
        slidesPerView: 5
      },
    }
  });
});